<script setup lang="ts">
import { useRouter } from 'vue-router'
import type { Envelope } from '@/stores/useEnvelopeStore'

const props = defineProps<{ params: { data: Envelope } }>()
const router = useRouter()

function goToPartner() {
  const partnerId = props.params.data.company?.referenceExterne
  if (partnerId) {
    router.push(`/partner/${partnerId}`)
  }
}
</script>

<template>
  <div class="text-sm">
    <button
      v-if="params.data.company?.name && params.data.company?.referenceExterne"
      class="link link-hover text-left"
      @click="goToPartner"
    >
      {{ params.data.company.name }}
    </button>
    <span v-else-if="params.data.company?.name">
      {{ params.data.company.name }}
    </span>
    <span v-else class="text-gray-400">-</span>
  </div>
</template>
